import { render, staticRenderFns } from "./AssessmentAcceleratorIntro.vue?vue&type=template&id=6a637368&scoped=true&"
import script from "./AssessmentAcceleratorIntro.vue?vue&type=script&lang=js&"
export * from "./AssessmentAcceleratorIntro.vue?vue&type=script&lang=js&"
import style0 from "./AssessmentAcceleratorIntro.vue?vue&type=style&index=0&id=6a637368&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a637368",
  null
  
)

export default component.exports